<template>
  <div class="rf-page">
    <div class="rf-container">
      <!-- HEADER -->
      <div class="rf-header">
        <h2 class="rf-title">🔄 Qaytarilgan mahsulotlar</h2>
        <div class="rf-header-actions">
          <button class="rf-add" @click="openCreate()">+ Qaytarish qo'shish</button>
          <div class="rf-date-range">
            <input type="date" v-model="filters.date1" class="rf-date" @change="load()" />
            <span class="rf-date-sep">—</span>
            <input type="date" v-model="filters.date2" class="rf-date" @change="load()" />
          </div>
          <div class="rf-quick">
            <button class="rf-quick-btn" @click="setMonth()">Oy</button>
            <button class="rf-quick-btn" @click="setToday()">Bugun</button>
          </div>
          <input v-model="search" type="search" class="rf-search" placeholder="🔍 Mijoz / izoh..." />
          <button class="rf-refresh" @click="load()" title="Yangilash"><b-icon icon="arrow-repeat"></b-icon></button>
        </div>
      </div>

      <!-- TOTALS -->
      <div class="rf-totals" v-if="!loading">
        <div class="rf-tcard"><div class="rf-tlabel">Qaytarishlar</div><div class="rf-tval">{{ filtered.length }} ta</div></div>
        <div class="rf-tcard"><div class="rf-tlabel">Jami summa</div><div class="rf-tval">{{ formatMoney(totalSumma) }} <small>UZS</small></div></div>
        <div class="rf-tcard"><div class="rf-tlabel">Mahsulot soni</div><div class="rf-tval">{{ formatMoney(totalCount) }} ta</div></div>
      </div>

      <!-- TABLE -->
      <div class="rf-table-wrap">
        <table class="rf-table">
          <thead>
            <tr>
              <th>№</th><th>SANA</th><th>MIJOZ</th><th>SONI</th><th>SUMMA</th>
              <th>TO'LOV</th><th>OMBOR</th><th>IZOH</th><th>AMAL</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in filtered" :key="r.id" @dblclick="openView(r.id)">
              <td><span class="rf-id">{{ r.number || r.id }}</span></td>
              <td class="rf-muted">{{ formatDate(r.created_at) }}</td>
              <td>{{ r.kontragent ? r.kontragent.name : '—' }}</td>
              <td>{{ formatMoney(r.count_all) }}</td>
              <td class="rf-summa">{{ formatMoney(r.summa) }}</td>
              <td>
                <span v-if="r.payments && r.payments.length" class="rf-chips">
                  <span v-for="p in r.payments" :key="p.id" class="rf-chip">
                    {{ p.pay_type ? p.pay_type.name : '?' }}: {{ formatMoney(p.summa) }}
                  </span>
                </span>
                <span v-else-if="r.kontragent" class="rf-tag debt">Qarzdan</span>
                <span v-else class="rf-muted">—</span>
              </td>
              <td>
                <span class="rf-tag" :class="r.restock === false ? 'scrap' : 'stock'">
                  {{ r.restock === false ? 'Yaroqsiz' : 'Omborga' }}
                </span>
              </td>
              <td class="rf-muted rf-comment">{{ r.comment }}</td>
              <td>
                <div class="rf-actions">
                  <button class="rf-btn view" @click="openView(r.id)" title="Ko'rish"><b-icon icon="eye"></b-icon></button>
                  <button class="rf-btn print" @click="printRefund(r.id)" title="Chek chiqarish"><b-icon icon="printer"></b-icon></button>
                  <button class="rf-btn edit" @click="openEdit(r.id)" title="Tahrirlash"><b-icon icon="pencil"></b-icon></button>
                  <button class="rf-btn del" @click="deleteRefund(r)" title="O'chirish"><b-icon icon="trash"></b-icon></button>
                </div>
              </td>
            </tr>
            <tr v-if="!loading && filtered.length === 0">
              <td colspan="9" class="rf-empty">Ma'lumot topilmadi</td>
            </tr>
            <tr v-if="loading"><td colspan="9" class="rf-empty">Yuklanmoqda...</td></tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- VIEW MODAL -->
    <div v-if="view.show" class="rf-overlay" @click.self="view.show = false">
      <div class="rf-modal">
        <div class="rf-mhead">
          <h3>🔄 Qaytarish #{{ view.data && (view.data.number || view.data.id) }}</h3>
          <button class="rf-close" @click="view.show = false">&times;</button>
        </div>
        <div class="rf-mbody" v-if="view.data">
          <div class="rf-info-grid">
            <div><span class="rf-il">Sana:</span> {{ formatDate(view.data.created_at) }}</div>
            <div><span class="rf-il">Mijoz:</span> {{ view.data.kontragent ? view.data.kontragent.name : '— (mijozsiz)' }}</div>
            <div><span class="rf-il">Sklad:</span> {{ view.data.sklad ? view.data.sklad.name : '' }}</div>
            <div><span class="rf-il">Ombor:</span>
              <span class="rf-tag" :class="view.data.restock === false ? 'scrap' : 'stock'">
                {{ view.data.restock === false ? 'Qaytmadi (yaroqsiz)' : 'Omborga qaytdi' }}
              </span>
            </div>
          </div>

          <h4 class="rf-sec">Mahsulotlar</h4>
          <table class="rf-mini">
            <thead><tr><th>Nomi</th><th>Soni</th><th>Narx</th><th>Summa</th></tr></thead>
            <tbody>
              <tr v-for="it in (view.data.refund_table || [])" :key="it.id">
                <td>{{ it.product ? it.product.extra_name : ('#' + it.product_id) }}</td>
                <td>{{ formatMoney(it.count) }}</td>
                <td>{{ formatMoney(it.price) }}</td>
                <td>{{ formatMoney(it.summa) }}</td>
              </tr>
            </tbody>
            <tfoot><tr><td colspan="3">JAMI</td><td>{{ formatMoney(view.data.summa) }} UZS</td></tr></tfoot>
          </table>

          <h4 class="rf-sec">Pul qaytarish</h4>
          <div v-if="view.data.payments && view.data.payments.length" class="rf-pay-list">
            <div v-for="p in view.data.payments" :key="p.id" class="rf-pay-row">
              <span>{{ p.pay_type ? p.pay_type.name : '?' }}</span>
              <b>{{ formatMoney(p.summa) }} {{ Number(p.dollar_rate) > 1 ? 'USD' : 'UZS' }}</b>
            </div>
          </div>
          <div v-else class="rf-muted">
            {{ view.data.kontragent ? 'Pul qaytarilmadi — mijoz qarzidan ushlandi' : 'Pul qaytarilmadi (faqat ombor)' }}
          </div>
        </div>
        <div class="rf-mfoot">
          <button class="rf-mbtn cancel" @click="view.show = false">Yopish</button>
          <button class="rf-mbtn print" @click="printRefundDoc(view.data)">🖨 Chek</button>
          <button class="rf-mbtn save" @click="view.show = false; openEdit(view.data.id)">✏️ Tahrirlash</button>
        </div>
      </div>
    </div>

    <!-- EDIT MODAL -->
    <div v-if="edit.show" class="rf-overlay" @click.self="edit.show = false">
      <div class="rf-modal">
        <div class="rf-mhead">
          <h3>{{ edit.mode === 'create' ? '➕ Yangi qaytarish' : ('✏️ Qaytarishni tahrirlash #' + edit.id) }}</h3>
          <button class="rf-close" @click="edit.show = false">&times;</button>
        </div>
        <div class="rf-mbody">
          <div class="rf-warn-banner" v-if="edit.mode === 'edit'">
            ⚠️ Saqlasangiz eski yozuvlar (ombor, kassa, mijoz qarzi) qaytadan hisoblanadi.
          </div>

          <div class="rf-field">
            <label>Mijoz</label>
            <v-select :options="clients" v-model="edit.kontragent" :reduce="c => c" label="name"
              placeholder="Mijozsiz (bo'sh qoldiring)" />
          </div>

          <!-- Mahsulot qo'shish: qidiruv + skaner -->
          <div class="rf-field">
            <label>Mahsulot qo'shish</label>
            <div class="rf-add-grid">
              <v-select
                :options="productResults"
                v-model="productPicker"
                :reduce="p => p"
                label="name"
                :filterable="false"
                placeholder="Nomi yoki artikul bo'yicha qidirish..."
                @search="onProductSearch"
                @input="onProductPicked"
              >
                <template #option="p">{{ p.name }} <small v-if="p.balance != null">· qoldiq: {{ formatMoney(p.balance) }}</small></template>
                <template #no-options>Yozing — qidiriladi...</template>
              </v-select>
              <input v-model="scannerCode" @keyup.enter="onScan" class="rf-inp full" placeholder="📷 Shtrix skaner..." />
            </div>
          </div>

          <h4 class="rf-sec">Mahsulotlar</h4>
          <table class="rf-mini editable">
            <thead><tr><th>Nomi</th><th>Soni</th><th>Narx</th><th>Summa</th><th></th></tr></thead>
            <tbody>
              <tr v-for="(it, i) in edit.items" :key="i">
                <td>{{ it.name }}</td>
                <td><input type="number" min="0" step="any" v-model.number="it.count" class="rf-inp" /></td>
                <td><input type="number" min="0" step="any" v-model.number="it.price" class="rf-inp" /></td>
                <td>{{ formatMoney(Number(it.count || 0) * Number(it.price || 0)) }}</td>
                <td><button class="rf-x" @click="edit.items.splice(i, 1)">&times;</button></td>
              </tr>
            </tbody>
            <tfoot><tr><td colspan="3">JAMI</td><td colspan="2">{{ formatMoney(editTotal) }} UZS</td></tr></tfoot>
          </table>

          <div class="rf-field">
            <label class="rf-toggle">
              <input type="checkbox" v-model="edit.restock" />
              <span><b>📦 Mahsulot omborga qaytsin</b>
                <small v-if="!edit.restock" class="rf-warn-txt">Yaroqsiz — ombor o'zgarmaydi</small>
              </span>
            </label>
          </div>

          <!-- To'lov rejimi -->
          <div class="rf-field">
            <label>Pul qaytarish (kassadan)?</label>
            <label class="rf-toggle">
              <input type="checkbox" v-model="edit.cashRefund" />
              <span>{{ edit.cashRefund ? 'Ha — to\'lov turlari bo\'yicha' : 'Yo\'q (qarzdan / faqat ombor)' }}</span>
            </label>
            <div v-if="edit.cashRefund" class="rf-paytypes">
              <div v-for="pt in payTypes" :key="pt.id" class="rf-pay-input-row">
                <label>{{ isDollarPt(pt) ? '💲' : '💵' }} {{ pt.name }} {{ isDollarPt(pt) ? '(USD)' : '(UZS)' }}</label>
                <input type="number" min="0" step="any" v-model.number="edit.payAmounts[pt.id]" class="rf-inp" placeholder="0" />
              </div>
              <div class="rf-pay-sum" :class="Math.abs(editPayEntered - editTotal) < 1 ? 'ok' : 'bad'">
                Kiritildi: <b>{{ formatMoney(editPayEntered) }}</b> / Kerakli: <b>{{ formatMoney(editTotal) }}</b> UZS
              </div>
            </div>
          </div>

          <div class="rf-field">
            <label>Izoh</label>
            <input v-model="edit.comment" type="text" class="rf-inp full" placeholder="Izoh..." />
          </div>
        </div>
        <div class="rf-mfoot">
          <button class="rf-mbtn cancel" @click="edit.show = false" :disabled="edit.saving">Bekor</button>
          <button class="rf-mbtn save" @click="saveEdit()" :disabled="edit.saving || edit.items.length === 0">
            {{ edit.saving ? 'Saqlanmoqda...' : '💾 Saqlash' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {
  fetchSkladSettings, receiptHeaderHtml, itemBlockHtml,
  openReceiptWindow, formatMoney as fmtMoney, formatDateTime,
} from '@/utils/receipt';

export default {
  name: 'RefundIndex',
  data() {
    return {
      skladSettings: { firmName: '', phone: '', checkWord: '', logoUrl: '' },
      refunds: [],
      loading: false,
      search: '',
      filters: { date1: '', date2: '' },
      payTypes: [],
      clients: [],
      dollarRate: 12500,
      // Mahsulot qidirish (create/edit modalida)
      productResults: [],
      productPicker: null,
      productSearchTimer: null,
      scannerCode: '',
      view: { show: false, data: null },
      edit: {
        show: false, mode: 'edit', saving: false, id: null,
        kontragent: null, items: [], restock: true, cashRefund: false,
        payAmounts: {}, comment: '',
        created_at: null, sklad_id: null, number: 0, dollar_rate: 1,
      },
    };
  },
  computed: {
    filtered() {
      const q = (this.search || '').toLowerCase().trim();
      if (!q) return this.refunds;
      return this.refunds.filter(r =>
        (r.kontragent && r.kontragent.name && r.kontragent.name.toLowerCase().includes(q)) ||
        (r.comment && r.comment.toLowerCase().includes(q))
      );
    },
    totalSumma() { return this.filtered.reduce((s, r) => s + Number(r.summa || 0), 0); },
    totalCount() { return this.filtered.reduce((s, r) => s + Number(r.count_all || 0), 0); },
    editTotal() {
      return this.edit.items.reduce((s, it) => s + Number(it.count || 0) * Number(it.price || 0), 0);
    },
    editPayEntered() {
      return (this.payTypes || []).reduce((sum, pt) => {
        const amt = Number(this.edit.payAmounts[pt.id] || 0);
        return sum + (this.isDollarPt(pt) ? amt * Number(this.dollarRate || 0) : amt);
      }, 0);
    },
  },
  mounted() {
    this.setMonth();           // default: oy boshi — oy oxiri
    this.loadPayTypes();
    this.loadClients();
    this.loadDollarRate();
    this.loadSkladSettings();
  },
  methods: {
    async loadSkladSettings() {
      this.skladSettings = await fetchSkladSettings(axios);
    },
    // Ro'yxatdagi qatordan chek: to'liq hujjatni olib (mahsulot nomlari, to'lovlar) chiqaramiz
    async printRefund(id) {
      try {
        const res = await axios.get(`/api/v1/refund/id/${id}`);
        this.printRefundDoc(res.data);
      } catch (e) {
        alert("Chek uchun ma'lumot yuklanmadi");
      }
    },
    printRefundDoc(doc) {
      if (!doc) return;
      const s = this.skladSettings;
      const rows = (doc.refund_table || []).map(it => ({
        name: (it.product && (it.product.extra_name || it.product.name)) || ('#' + it.product_id),
        count: Number(it.count || 0),
        // O'lchov birligi mahsulot kartochkasidan (kg, m, m², sht...)
        unit: (it.product && it.product.unit && it.product.unit.name) || '',
        price: Number(it.price || 0),
        summa: Number(it.summa != null ? it.summa : Number(it.count || 0) * Number(it.price || 0)),
      }));
      const totalQty = rows.reduce((sum, r) => sum + r.count, 0);
      const totalSum = Number(doc.summa || rows.reduce((sum, r) => sum + r.summa, 0));

      const isDollarPay = (p) => {
        const n = String((p.pay_type && p.pay_type.name) || '').toLowerCase();
        return n.includes('dollar') || n.includes('usd') || n.includes('$') || n.startsWith('доллар');
      };
      const payments = (doc.payments || []).filter(p => Number(p.summa || 0) > 0);
      let payHtml = '';
      if (payments.length > 0) {
        payHtml = payments.map(p => {
          const name = (p.pay_type && p.pay_type.name) || ("To'lov #" + p.pay_type_id);
          const amount = isDollarPay(p) ? `$${fmtMoney(p.summa)}` : `${fmtMoney(p.summa)} UZS`;
          return `<div class="leader-line"><span class="ll-left">Qaytarildi (${name})</span><span class="ll-dots"></span><span class="ll-right">${amount}</span></div>`;
        }).join('');
      } else {
        const txt = doc.kontragent ? "Mijoz qarzidan ushlandi" : "Pul qaytarilmadi (faqat ombor)";
        payHtml = `<div class="leader-line"><span class="ll-left">Pul qaytarish</span><span class="ll-dots"></span><span class="ll-right">${txt}</span></div>`;
      }

      const body = `
        ${receiptHeaderHtml(s, formatDateTime(doc.created_at), 'Qaytarish cheki')}
        <div class="receipt-info">
          <div class="info-row"><span class="info-label">Hujjat:</span><span class="info-value">№ ${doc.number || doc.id}</span></div>
          <div class="info-row"><span class="info-label">Mijoz:</span><span class="info-value">${doc.kontragent ? doc.kontragent.name : "NOMA'LUM"}</span></div>
          <div class="info-row"><span class="info-label">Ombor:</span><span class="info-value">${doc.restock === false ? 'Qaytmadi (yaroqsiz)' : 'Omborga qaytdi'}</span></div>
        </div>
        <div class="items-section">${rows.map(itemBlockHtml).join('')}</div>
        <div class="calc-section">
          <div class="leader-line"><span class="ll-left">Qaytarilgan mahsulot soni</span><span class="ll-dots"></span><span class="ll-right">${fmtMoney(totalQty)} birlik.</span></div>
          <div class="leader-line ll-jami"><span class="ll-left">JAMI QAYTARILDI</span><span class="ll-dots"></span><span class="ll-right">${fmtMoney(totalSum)} UZS</span></div>
          ${payHtml}
        </div>
        ${doc.comment ? `<div class="refund-comment">Izoh: ${doc.comment}</div>` : ''}
        <div class="receipt-divider"></div>
        <div class="receipt-footer">
          ${s.checkWord ? `<div class="check-word">${s.checkWord}</div>` : ''}
        </div>`;

      openReceiptWindow(`Qaytarish #${doc.number || doc.id}`, body);
    },
    formatMoney(v) {
      const n = Number(v || 0);
      return n.toLocaleString('ru-RU', { maximumFractionDigits: 2 }).replace(/,/g, ' ');
    },
    formatDate(ts) {
      if (!ts) return '';
      const d = new Date(Number(ts) * 1000);
      return d.toLocaleDateString('ru-RU') + ' ' + d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
    },
    isDollarPt(pt) {
      const n = String((pt && pt.name) || '').toLowerCase();
      return n.includes('dollar') || n.includes('usd') || n.includes('$') || n.startsWith('доллар');
    },
    fmtDateInput(d) { return d.toISOString().slice(0, 10); },
    setMonth() {
      const now = new Date();
      const first = new Date(now.getFullYear(), now.getMonth(), 1);
      const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      this.filters.date1 = this.fmtDateInput(first);
      this.filters.date2 = this.fmtDateInput(last);
      this.load();
    },
    setToday() {
      const t = this.fmtDateInput(new Date());
      this.filters.date1 = t;
      this.filters.date2 = t;
      this.load();
    },
    toUnix(dateStr, endOfDay = false) {
      if (!dateStr) return null;
      const d = new Date(dateStr);
      if (endOfDay) d.setHours(23, 59, 59, 999); else d.setHours(0, 0, 0, 0);
      return Math.floor(d.getTime() / 1000);
    },
    async load() {
      this.loading = true;
      try {
        const params = {};
        const d1 = this.toUnix(this.filters.date1, false);
        const d2 = this.toUnix(this.filters.date2, true);
        if (d1) params.date1 = d1;
        if (d2) params.date2 = d2;
        const res = await axios.get('/api/v1/refund', { params });
        this.refunds = Array.isArray(res.data) ? res.data : (res.data.data || []);
      } catch (e) {
        this.refunds = [];
      } finally {
        this.loading = false;
      }
    },
    loadPayTypes() {
      axios.get('/api/v1/pay-type/').then(r => {
        const list = Array.isArray(r.data) ? r.data : (r.data.data || []);
        this.payTypes = list.sort((a, b) => a.id - b.id);
      }).catch(() => { this.payTypes = [{ id: 1, name: 'Naqd' }, { id: 2, name: 'Plastik' }, { id: 3, name: 'Dollar' }]; });
    },
    loadClients() {
      axios.get('/api/v1/kontragent/type/1').then(r => {
        this.clients = Array.isArray(r.data) ? r.data : (r.data.data || []);
      }).catch(() => { this.clients = []; });
    },
    loadDollarRate() {
      axios.get('/api/v1/dollar-exchange-rate/last').then(r => {
        const rate = Number((r.data && r.data.rate) || 0);
        if (rate > 0) this.dollarRate = rate;
      }).catch(() => {});
    },
    openCreate() {
      const payAmounts = {};
      (this.payTypes || []).forEach(pt => { payAmounts[pt.id] = 0; });
      this.productResults = [];
      this.productPicker = null;
      this.scannerCode = '';
      this.edit = {
        show: true, mode: 'create', saving: false, id: null,
        kontragent: null, items: [], restock: true, cashRefund: false,
        payAmounts, comment: '',
        created_at: Math.floor(Date.now() / 1000),
        sklad_id: parseInt(localStorage.getItem('sklad_id') || '1'),
        number: 0,
        dollar_rate: Number(this.dollarRate || 1),
      };
    },
    onProductSearch(query, loading) {
      if (!query || query.length < 1) return;
      if (loading) loading(true);
      clearTimeout(this.productSearchTimer);
      this.productSearchTimer = setTimeout(async () => {
        try {
          const sklad_id = this.edit.sklad_id || parseInt(localStorage.getItem('sklad_id') || '1');
          const res = await axios.post('/api/v1/product/all-price-balance/0', {
            sklad_id, keyword: query, limit: 30, page: 1,
          });
          const list = Array.isArray(res.data) ? res.data : (res.data.items || res.data.data || []);
          this.productResults = list.filter(p => !p.is_folder).map(p => {
            const reg = p.price_register || {};
            return {
              id: p.id,
              name: p.extra_name || p.name || ('#' + p.id),
              price: Number(reg.chakana_price || p.chakana_price || 0),
              balance: p.balance,
            };
          });
        } catch (e) {
          this.productResults = [];
        } finally {
          if (loading) loading(false);
        }
      }, 350);
    },
    onProductPicked(p) {
      if (p && p.id) {
        this.addRefundItem(p);
        this.$nextTick(() => { this.productPicker = null; });
      }
    },
    async onScan() {
      const code = (this.scannerCode || '').trim();
      if (!code) return;
      try {
        const res = await axios.get(`/api/v1/product/shtrix/${encodeURIComponent(code)}`);
        const p = Array.isArray(res.data) ? res.data[0] : res.data;
        if (!p || !p.id) { alert(`"${code}" topilmadi`); this.scannerCode = ''; return; }
        const reg = p.price_register || {};
        this.addRefundItem({
          id: p.id,
          name: p.extra_name || p.name || ('#' + p.id),
          price: Number(reg.chakana_price || p.chakana_price || p.price || 0),
        });
        this.scannerCode = '';
      } catch (e) {
        alert('Skanerga xato: ' + (e.response?.data?.message || e.message));
        this.scannerCode = '';
      }
    },
    addRefundItem(p) {
      const ex = this.edit.items.find(it => it.product_id === p.id);
      if (ex) { ex.count = Number(ex.count || 0) + 1; }
      else {
        this.edit.items.push({
          product_id: p.id,
          name: p.name,
          count: 1,
          price: Number(p.price || 0),
        });
      }
    },
    async openView(id) {
      try {
        const res = await axios.get(`/api/v1/refund/id/${id}`);
        this.view.data = res.data;
        this.view.show = true;
      } catch (e) {
        alert("Ma'lumotni yuklashda xato");
      }
    },
    async openEdit(id) {
      try {
        const res = await axios.get(`/api/v1/refund/id/${id}`);
        const r = res.data;
        const payAmounts = {};
        (this.payTypes || []).forEach(pt => { payAmounts[pt.id] = 0; });
        (r.payments || []).forEach(p => { payAmounts[p.pay_type_id] = Number(p.summa || 0); });
        this.productResults = [];
        this.productPicker = null;
        this.scannerCode = '';
        this.edit = {
          show: true, mode: 'edit', saving: false, id: r.id,
          kontragent: r.kontragent_id ? (this.clients.find(c => c.id === r.kontragent_id) || { id: r.kontragent_id, name: (r.kontragent && r.kontragent.name) || '' }) : null,
          items: (r.refund_table || []).map(it => ({
            product_id: it.product_id,
            name: it.product ? it.product.extra_name : ('#' + it.product_id),
            count: Number(it.count || 0),
            price: Number(it.price || 0),
          })),
          restock: r.restock !== false,
          cashRefund: !!(r.payments && r.payments.length),
          payAmounts,
          comment: r.comment || '',
          dollar_rate: Number(r.dollar_rate || this.dollarRate || 1),
          created_at: r.created_at,
          sklad_id: r.sklad_id,
          number: r.number,
        };
      } catch (e) {
        alert("Ma'lumotni yuklashda xato");
      }
    },
    async saveEdit() {
      if (this.edit.items.length === 0) return;
      this.edit.saving = true;
      try {
        const totalCount = this.edit.items.reduce((s, it) => s + Number(it.count || 0), 0);
        const payments = this.edit.cashRefund
          ? (this.payTypes || [])
              .map(pt => ({ pay_type_id: pt.id, isDollar: this.isDollarPt(pt), summa: Number(this.edit.payAmounts[pt.id] || 0) }))
              .filter(p => p.summa > 0)
              .map(p => ({ pay_type_id: p.pay_type_id, summa: p.summa, dollar_rate: p.isDollar ? Number(this.edit.dollar_rate || 1) : 1 }))
          : [];
        const payload = {
          created_at: this.edit.created_at,
          updated_at: Math.floor(Date.now() / 1000),
          sklad_id: this.edit.sklad_id,
          kontragent_id: this.edit.kontragent ? this.edit.kontragent.id : 0,
          summa: this.editTotal,
          count_all: totalCount,
          skidka_summa: 0,
          payments,
          cash_summa: 0, plastic_summa: 0, dollar_summa: 0,
          dollar_rate: Number(this.edit.dollar_rate || 1),
          pay_type_id: 1,
          price_type: 'chakana',
          restock: this.edit.restock !== false,
          comment: this.edit.comment || '',
          number: this.edit.number || 0,
          refund_table: this.edit.items.map(it => ({
            product_id: it.product_id,
            count: Number(it.count),
            price: Number(it.price),
            summa: Number(it.count) * Number(it.price),
          })),
        };
        if (this.edit.mode === 'create') {
          await axios.post('/api/v1/refund', payload);
        } else {
          await axios.patch(`/api/v1/refund/id/${this.edit.id}`, payload);
        }
        this.edit.show = false;
        this.load();
      } catch (e) {
        alert('Saqlashda xato: ' + (e.response?.data?.message || e.message));
      } finally {
        this.edit.saving = false;
      }
    },
    async deleteRefund(r) {
      const debtNote = r.kontragent
        ? `\n\n⚠️ "${r.kontragent.name}" mijoz qarzi va ombor/kassa yozuvlari qaytariladi (teskari hisoblanadi).`
        : `\n\n⚠️ Ombor/kassa yozuvlari qaytariladi.`;
      if (!confirm(`Qaytarish #${r.number || r.id} (${this.formatMoney(r.summa)} UZS) o'chirilsinmi?${debtNote}`)) return;
      try {
        await axios.delete(`/api/v1/refund/id/${r.id}`);
        this.refunds = this.refunds.filter(x => x.id !== r.id);
      } catch (e) {
        alert("O'chirishda xato: " + (e.response?.data?.message || e.message));
      }
    },
  },
};
</script>

<style scoped>
.rf-page { padding: 16px; background: #f5f7fb; min-height: 100vh; font-size: 14px; }
.rf-container { max-width: 1400px; margin: 0 auto; }
.rf-header { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; margin-bottom: 16px; }
.rf-title { font-size: 22px; font-weight: 700; color: #2d3748; margin: 0; }
.rf-header-actions { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.rf-date-range { display: flex; align-items: center; gap: 6px; background: #fff; border: 1px solid #e2e8f0; border-radius: 8px; padding: 4px 8px; }
.rf-date { border: none; outline: none; font-size: 13px; }
.rf-date-sep { color: #a0aec0; }
.rf-quick { display: flex; gap: 4px; }
.rf-quick-btn { padding: 7px 12px; background: #edf2f7; border: 1px solid #cbd5e0; border-radius: 6px; cursor: pointer; font-size: 12px; }
.rf-quick-btn:hover { background: #e2e8f0; }
.rf-search { padding: 8px 12px; border: 1px solid #e2e8f0; border-radius: 8px; font-size: 13px; min-width: 180px; }
.rf-add { background: #be185d; color: #fff; border: none; padding: 9px 16px; border-radius: 8px; cursor: pointer; font-weight: 700; font-size: 13px; }
.rf-add:hover { background: #9d174d; }
.rf-add-grid { display: grid; grid-template-columns: 1fr 200px; gap: 8px; }
.rf-refresh { background: #fff; border: 1px solid #e2e8f0; padding: 8px 12px; border-radius: 8px; cursor: pointer; }
@media (max-width: 640px) { .rf-add-grid { grid-template-columns: 1fr; } }

.rf-totals { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 12px; margin-bottom: 16px; }
.rf-tcard { background: #fff; padding: 14px 18px; border-radius: 10px; box-shadow: 0 1px 3px rgba(0,0,0,.05); border-left: 3px solid #be185d; }
.rf-tlabel { font-size: 12px; color: #718096; margin-bottom: 4px; }
.rf-tval { font-size: 20px; font-weight: 700; color: #2d3748; }
.rf-tval small { font-size: 12px; color: #a0aec0; }

.rf-table-wrap { background: #fff; border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,.05); overflow-x: auto; }
.rf-table { width: 100%; border-collapse: collapse; }
.rf-table th { background: #f7fafc; color: #4a5568; font-size: 11px; font-weight: 700; text-transform: uppercase; padding: 12px 14px; text-align: left; border-bottom: 1px solid #edf2f7; }
.rf-table td { padding: 11px 14px; border-bottom: 1px solid #f4f7fb; vertical-align: middle; }
.rf-table tbody tr:hover { background: #fdf2f8; cursor: default; }
.rf-id { background: #fce7f3; color: #be185d; padding: 2px 9px; border-radius: 7px; font-weight: 700; font-size: 12px; }
.rf-summa { font-weight: 700; color: #be185d; }
.rf-muted { color: #94a3b8; }
.rf-comment { max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.rf-chips { display: flex; flex-wrap: wrap; gap: 4px; }
.rf-chip { background: #ebf8ff; color: #2c5282; padding: 2px 7px; border-radius: 6px; font-size: 11px; font-weight: 600; }
.rf-tag { padding: 3px 9px; border-radius: 6px; font-size: 11px; font-weight: 700; display: inline-block; }
.rf-tag.stock { background: #f0fff4; color: #276749; }
.rf-tag.scrap { background: #fff5f5; color: #c53030; }
.rf-tag.debt { background: #fffaf0; color: #b7791f; }
.rf-actions { display: flex; gap: 5px; }
.rf-btn { width: 30px; height: 30px; border-radius: 7px; border: none; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; }
.rf-btn.view { background: #ebf8ff; color: #2b6cb0; }
.rf-btn.print { background: #f0fdf4; color: #10b981; }
.rf-btn.edit { background: #eff6ff; color: #2563eb; }
.rf-btn.del { background: #fff5f5; color: #e53e3e; }
.rf-btn:hover { filter: brightness(0.95); }
.rf-empty { text-align: center; padding: 32px; color: #a0aec0; }

/* Modal */
.rf-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.45); display: flex; align-items: center; justify-content: center; z-index: 1050; padding: 16px; }
.rf-modal { background: #fff; width: 100%; max-width: 600px; max-height: 90vh; border-radius: 14px; display: flex; flex-direction: column; overflow: hidden; }
.rf-mhead { display: flex; justify-content: space-between; align-items: center; padding: 16px 20px; border-bottom: 1px solid #edf2f7; }
.rf-mhead h3 { margin: 0; font-size: 17px; font-weight: 700; color: #2d3748; }
.rf-close { background: none; border: none; font-size: 26px; color: #a0aec0; cursor: pointer; line-height: 1; }
.rf-mbody { padding: 20px; overflow-y: auto; }
.rf-mfoot { display: flex; justify-content: flex-end; gap: 10px; padding: 14px 20px; border-top: 1px solid #edf2f7; background: #f7fafc; }
.rf-mbtn { padding: 9px 18px; border-radius: 8px; border: none; cursor: pointer; font-weight: 700; font-size: 13px; }
.rf-mbtn.cancel { background: #edf2f7; color: #4a5568; }
.rf-mbtn.save { background: #be185d; color: #fff; }
.rf-mbtn.print { background: #ecfdf5; color: #047857; }
.rf-mbtn:disabled { opacity: .6; cursor: not-allowed; }

.rf-info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; font-size: 13px; margin-bottom: 14px; }
.rf-il { color: #718096; font-weight: 600; }
.rf-sec { font-size: 13px; font-weight: 700; color: #4a5568; margin: 14px 0 8px; text-transform: uppercase; }
.rf-mini { width: 100%; border-collapse: collapse; font-size: 13px; }
.rf-mini th { background: #f7fafc; color: #718096; padding: 7px 10px; text-align: left; font-size: 11px; }
.rf-mini td { padding: 7px 10px; border-bottom: 1px solid #f4f7fb; }
.rf-mini tfoot td { font-weight: 700; background: #fdf2f8; }
.rf-pay-list { display: flex; flex-direction: column; gap: 6px; }
.rf-pay-row { display: flex; justify-content: space-between; padding: 7px 12px; background: #f7fafc; border-radius: 7px; }

.rf-warn-banner { background: #fffaf0; border: 1px solid #fbd38d; color: #975a16; padding: 10px 12px; border-radius: 8px; font-size: 12px; margin-bottom: 14px; }
.rf-field { margin-bottom: 14px; }
.rf-field > label { display: block; font-size: 12px; font-weight: 700; color: #64748b; margin-bottom: 6px; }
.rf-inp { width: 90px; padding: 6px 8px; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 13px; text-align: right; }
.rf-inp.full { width: 100%; text-align: left; }
.rf-x { background: #fff5f5; color: #e53e3e; border: none; width: 24px; height: 24px; border-radius: 6px; cursor: pointer; font-size: 16px; }
.rf-toggle { display: flex; align-items: flex-start; gap: 8px; cursor: pointer; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 9px 12px; }
.rf-toggle input { margin-top: 3px; width: 17px; height: 17px; }
.rf-toggle span { font-size: 13px; color: #334155; display: flex; flex-direction: column; }
.rf-warn-txt { color: #c53030; font-size: 11px; }
.rf-paytypes { margin-top: 10px; background: #fffbeb; border: 1px solid #fde68a; border-radius: 8px; padding: 10px; }
.rf-pay-input-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 7px; }
.rf-pay-input-row label { font-size: 13px; color: #475569; }
.rf-pay-sum { text-align: right; font-size: 12px; padding-top: 6px; border-top: 1px dashed #fde68a; }
.rf-pay-sum.ok { color: #276749; }
.rf-pay-sum.bad { color: #c53030; }

.editable .rf-inp { width: 80px; }
@media (max-width: 640px) {
  .rf-info-grid { grid-template-columns: 1fr; }
}
</style>
